<div class="non-residency-offline">
    <div class="box">
        <p class="stacy"><img src="../../../../../../assets/img/avatar-stacy2.png" alt="stacy"></p>
        <p>Your state return is complete. Great job!</p>
        <br />
        <p>State is finished</p>
        <button (click)="submit()" class="btn btn-primary">Next</button>
    </div>
</div>